import db from "astrid-firebase/src/db";

export default function useStudiosQuery({ organizationId }) {
	return db.collection("studios").where("producerId", "==", organizationId);
}
